import BaseModel from "lib/model";
import AddressModel from "../address";

export default BaseModel.extend({
    props: {
        phone: { type: "string", required: false },
        website: { type: "string", required: false },
        emails: { type: "array", required: false, default: () => [] },
        title: { type: "string", required: false },
        phone_cell: { type: "string", required: false },
        phone_office: { type: "string", required: false },
    },
    children: {
        address: AddressModel,
    },
});
